import { type FC } from "react";

import {
  MenuSeparator as HeadlessUIMenuSeparator,
  type MenuSeparatorProps as HeadlessUIMenuSeparatorProps,
} from "@headlessui/react";

export const MenuSeparator: FC<HeadlessUIMenuSeparatorProps> = (props) => (
  <HeadlessUIMenuSeparator {...props} className={"my-2 h-px bg-slate-200"} />
);
